import { Autocomplete, Grid, TextField } from "@material-ui/core";
import AdapterDateFns from "@material-ui/lab/AdapterDateFns";
import DatePicker from "@material-ui/lab/DatePicker";
import LocalizationProvider from "@material-ui/lab/LocalizationProvider";
import {
  addDays,
  addMonths,
  format,
  isValid,
  parse,
  startOfMonth,
} from "date-fns";
import { es } from "date-fns/locale";
import React, { useState } from "react";

const FORMATO_FECHA_BD = "yyyy/MM/dd";
const MES_DEFAULT_AÑO = "02";

function parsearFechaSiguienteCiclo(valor) {
  if (!valor) return null;
  const fecha = parse(valor, FORMATO_FECHA_BD, new Date());
  return isValid(fecha) ? fecha : null;
}

function calcularFechaCicloMensual() {
  return format(startOfMonth(addMonths(new Date(), 1)), FORMATO_FECHA_BD);
}

// Año coherente: si el mes elegido aún no ocurrió este año, usar el año
// actual; si ya pasó (o es el mes actual), saltar al próximo año. Misma
// fórmula que aplica el script de migración para planes anuales.
function calcularFechaCicloAnual(mes) {
  const hoy = new Date();
  const mesNum = parseInt(mes, 10);
  const mesActual = hoy.getMonth() + 1;
  const anio = mesNum > mesActual ? hoy.getFullYear() : hoy.getFullYear() + 1;
  return `${anio}/${mes}/01`;
}

function mesDeFecha(fecha) {
  return String(fecha.getMonth() + 1).padStart(2, "0");
}

export const FormFrecuenciaPlan = (props) => {
  const { formik } = props;
  const { touched, getFieldProps, errors, setFieldValue, values } = formik;

  const [tipoFrecuencia, setTipoFrecuencia] = useState({
    label:
      values.tipoFrecuencia === ""
        ? "Mes"
        : values.tipoFrecuencia === "MES"
          ? "Mes"
          : "Año",
    value: values.tipoFrecuencia === "" ? "MES" : values.tipoFrecuencia,
  });

  return (
    <Grid container spacing={2}>
      <Grid item xs={12} sm={5} md={4}>
        <TextField
          fullWidth
          disabled
          required
          type="Frecuencia"
          label="Frecuencia"
          onChange={formik.handleChange}
          {...getFieldProps("frecuencia")}
          error={Boolean(touched.frecuencia && errors.frecuencia)}
          helperText={touched.frecuencia && errors.frecuencia}
        />
      </Grid>
      <Grid item xs={12} sm={7} md={5}>
        <Autocomplete
          disablePortal
          id="combo-box-demo"
          options={options}
          value={tipoFrecuencia}
          isOptionEqualToValue={(option, value) => option.value === value.value}
          getOptionLabel={(option) => option.label}
          onChange={(event, newValue) => {
            if (newValue !== null) {
              setFieldValue("tipoFrecuencia", newValue.value);
              setTipoFrecuencia(newValue);
              if (newValue.value === "AÑO") {
                setFieldValue("mesCargaTareas", MES_DEFAULT_AÑO);
                setFieldValue("mesFacturacion", "03");
                setFieldValue(
                  "fechaSiguienteCiclo",
                  calcularFechaCicloAnual(MES_DEFAULT_AÑO),
                );
              } else {
                setFieldValue("mesCargaTareas", "");
                setFieldValue("mesFacturacion", "");
                setFieldValue(
                  "fechaSiguienteCiclo",
                  calcularFechaCicloMensual(),
                );
              }
            } else {
              setFieldValue("tipoFrecuencia", "");
              setTipoFrecuencia(null);
              setFieldValue("mesCargaTareas", "");
              setFieldValue("mesFacturacion", "");
            }
          }}
          renderInput={(params) => (
            <TextField
              required
              {...params}
              label="Tipo Frecuencia"
              {...getFieldProps("tipoFrecuencia")}
              error={Boolean(touched.tipoFrecuencia && errors.tipoFrecuencia)}
              helperText={touched.tipoFrecuencia && errors.tipoFrecuencia}
            />
          )}
        />
      </Grid>

      <Grid item xs={12} sm={12} md={9}>
        <LocalizationProvider dateAdapter={AdapterDateFns} locale={es}>
          <DatePicker
            label="Fecha del siguiente ciclo"
            minDate={addDays(new Date(), 1)}
            value={parsearFechaSiguienteCiclo(values.fechaSiguienteCiclo)}
            onChange={(fecha) => {
              if (fecha && isValid(fecha)) {
                setFieldValue(
                  "fechaSiguienteCiclo",
                  format(fecha, FORMATO_FECHA_BD),
                );
                // En planes anuales, mesCargaTareas se mantiene sincronizado
                // con el mes que el usuario eligió en el DatePicker.
                if (values.tipoFrecuencia === "AÑO") {
                  setFieldValue("mesCargaTareas", mesDeFecha(fecha));
                }
              } else {
                setFieldValue("fechaSiguienteCiclo", "");
              }
            }}
            renderInput={(params) => (
              <TextField
                {...params}
                fullWidth
                required
                error={Boolean(
                  touched.fechaSiguienteCiclo && errors.fechaSiguienteCiclo,
                )}
                helperText={
                  touched.fechaSiguienteCiclo && errors.fechaSiguienteCiclo
                }
              />
            )}
          />
        </LocalizationProvider>
      </Grid>
    </Grid>
  );
};

const options = [
  { label: "Mes", value: "MES" },
  { label: "Año", value: "AÑO" },
];
